import { gql } from '@graphql/__generated__';

export const LOT_WATERMARK_ENABLED_FRAGMENT = gql(/* GraphQL */ `
  fragment LotWatermarkEnabled on lots {
    id
    watermark_enabled
  }
`);

export const LOT_WATERMARK_CONFIG_FRAGMENT = gql(/* GraphQL */ `
  fragment LotWatermarkConfig on lots {
    ...LotWatermarkEnabled
    watermark_image_url
    watermark_position
    watermark_opacity
    watermark_scale
    watermark_rotation
    watermark_position_x
    watermark_position_y
  }
`);

export const GET_LOT_WATERMARK_CONFIG = gql(/* GraphQL */ `
  query GetLotWatermarkConfig($lotId: uuid!) {
    lots_by_pk(id: $lotId) {
      ...LotWatermarkConfig
    }
  }
`);

export const UPDATE_LOT_WATERMARK = gql(/* GraphQL */ `
  mutation UpdateLotWatermark($lotId: uuid!, $input: lots_set_input!) {
    update_lots_by_pk(pk_columns: { id: $lotId }, _set: $input) {
      ...LotWatermarkConfig
    }
  }
`);

export const COMPOSITE_WATERMARK_IMAGES = gql(/* GraphQL */ `
  mutation CompositeWatermarkImages($lot_id: uuid!) {
    composite_watermark_images(lot_id: $lot_id) {
      processed_count
      skipped_count
    }
  }
`);

export const GET_LAST_LOT_WATERMARK_CONFIG = gql(/* GraphQL */ `
  query GetLastLotWatermarkConfig($brokerId: uuid!) {
    lots(
      limit: 1
      order_by: { created_at: desc }
      where: { broker_id: { _eq: $brokerId }, watermark_enabled: { _eq: true } }
    ) {
      ...LotWatermarkConfig
    }
  }
`);
